export const SEARCH_SUGGESTIONS_LISTBOX_ID = 'srp_search-listbox';
export const SEARCH_INPUT_ID = 'srp_search-input';
export const SEARCH_COMBOBOX_WRAPPER_ID = 'srp_search-combobox';
